// Product-related constants for admin and public store
export const PRODUCT_CATEGORIES = [
  { key: "legumes", label: "Legumes" },
  { key: "fruta", label: "Fruta" },
  { key: "cabazes", label: "Cabazes" },
  { key: "aromaticas", label: "Aromáticas" },
  { key: "sazonais", label: "Produtos sazonais" },
  { key: "outros", label: "Outros" },
];

export const CATEGORY_LABEL = Object.fromEntries(
  PRODUCT_CATEGORIES.map((c) => [c.key, c.label])
);

export const PRODUCT_UNITS = [
  { key: "kg", label: "kg" },
  { key: "unidade", label: "unidade" },
  { key: "molho", label: "molho" },
  { key: "caixa", label: "caixa" },
  { key: "cabaz", label: "cabaz" },
  { key: "duzia", label: "dúzia" },
  { key: "litro", label: "litro" },
];

export const UNIT_LABEL = Object.fromEntries(PRODUCT_UNITS.map((u) => [u.key, u.label]));

// Resolve a stored image path/URL into an absolute URL the browser can render.
export function resolveImageUrl(p) {
  if (!p) return null;
  if (p.startsWith("http://") || p.startsWith("https://")) return p;
  return `${process.env.REACT_APP_BACKEND_URL}${p}`;
}
